var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2938 10.4742C18.2938 9.94827 18.2429 9.40541 18.1581 8.89648H10.8125V11.8992H15.0197C14.85 12.8661 14.2902 13.7144 13.4589 14.2572L15.9697 16.2081C17.4456 14.834 18.2938 12.8322 18.2938 10.4742Z",
    fill: "#4280EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8148 18.0737C12.9183 18.0737 14.6826 17.3781 15.9719 16.1906L13.4612 14.2567C12.7657 14.7317 11.8665 15.0031 10.8148 15.0031C8.77904 15.0031 7.06564 13.629 6.43796 11.7969L3.85938 13.7817C5.18259 16.4112 7.86296 18.0737 10.8148 18.0737Z",
    fill: "#34A353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43684 11.7805C6.11452 10.8135 6.11452 9.76173 6.43684 8.79476L3.85826 6.79297C2.75558 8.99833 2.75558 11.5939 3.85826 13.7823L6.43684 11.7805Z",
    fill: "#F6B704"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8148 5.58781C11.9174 5.57084 13.0032 5.99495 13.8005 6.75835L16.0228 4.51905C14.6148 3.19583 12.7487 2.48333 10.8148 2.5003C7.86296 2.5003 5.18259 4.1628 3.85938 6.79228L6.43796 8.79407C7.06564 6.94495 8.77904 5.58781 10.8148 5.58781Z",
    fill: "#E54335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.5a054c1d7baf2813b2fe1b22fe07c0a1.svg";
export { ForwardRef as ReactComponent };